import { buildUrl } from '@cascade/core/utils';
import type { TSdk } from '#observability/observability.types.ts';
import { injectScript } from '#utils/inject-script/index.ts';
import type { TGoogleTagManagerOptions } from './googleTagManager.types.ts';

const GOOGLE_TAG_MANAGER_ORIGIN = 'https://www.googletagmanager.com';
const GOOGLE_TAG_MANAGER_PATH = '/gtm.js';
const GOOGLE_TAG_MANAGER_SCRIPT_ID = 'googleTagManagerScript';

const googleTagManagerSdk: TSdk = {
  track: (name, properties) => {
    window.dataLayer?.push({ properties: null });
    window.dataLayer?.push({ event: name, properties });
  },
};

export const initGoogleTagManager = ({
  containerId,
}: TGoogleTagManagerOptions): TSdk => {
  const src = buildUrl(GOOGLE_TAG_MANAGER_ORIGIN, GOOGLE_TAG_MANAGER_PATH, {
    id: containerId,
  });

  const startedAt = Date.now();

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ 'gtm.start': startedAt, event: 'gtm.js' });
  injectScript({ id: GOOGLE_TAG_MANAGER_SCRIPT_ID, src });

  return googleTagManagerSdk;
};
